// Feature flags read from the current user's profile or a global settings doc.
// Default to OFF for safety. Caller passes the user/settings; we don't fetch here.

import { isSuperAdminOwner } from "./brokerageSettings";

export function isDriveBrokerEnabled({ user, globalSettings } = {}) {
  if (globalSettings?.features?.driveBroker === true) return true;
  if (user?.features?.driveBroker === true) return true;
  return false;
}

// The IMPACT Scorecard coaching tool. Visible to the super-admin owner today;
// roll out to a coached agent later by setting features.impactScorecard on
// their user record — no code change, no deploy.
export function isImpactScorecardEnabled({ user } = {}) {
  if (isSuperAdminOwner(user)) return true;
  return user?.features?.impactScorecard === true;
}

// Henry's personal Lead Tracker (Settings tab). Always on for the owner;
// share with a Client Care user by setting features.leadTracker on their
// user doc (dot-notation patch — see SharingDialog) — no deploy needed.
export function isLeadTrackerEnabled({ user } = {}) {
  if (isSuperAdminOwner(user)) return true;
  return user?.features?.leadTracker === true;
}
